import React from "react"
import type { ICheckoutMaterial } from "../../interface";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useLang } from "~/hooks/useLang";

interface TableMaterialsProps {
  readonly materials: readonly ICheckoutMaterial[];
  readonly status?: number;
}

export default function TableMaterials({ materials, status }: TableMaterialsProps) {
  const { translate } = useLang();
  const columnNames = [
    { key: 'name', nameColumn: translate('Name'), statusView: [1, 2, 3, 4, 5] },
    { key: 'group', nameColumn: translate('Material group'), statusView: [1, 2, 3, 4, 5] },
    { key: 'code', nameColumn: translate('Código'), statusView: [1, 2, 3, 4, 5] },
    { key: 'qtyCheckout', nameColumn: translate('Quantitade cautelada'), statusView: [1, 2, 3, 4, 5] },
    { key: 'qtyCheckin', nameColumn: translate('Quantitade devolvida'), statusView: [3, 4, 5] },
    { key: 'notes', nameColumn: translate('Notes'), statusView: [3, 4, 5] },
  ]

  return (
    <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 300 }}>
      <Table size="small" stickyHeader sx={{ tableLayout: 'fixed' }}>
        <TableHead>
          <TableRow>
            {columnNames.map((column) => (
              column.statusView.includes(status ?? 0) && (
                <TableCell key={column.key}>
                  <strong>
                    {column.nameColumn}
                  </strong>
                </TableCell>
              )
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {materials.length > 0 ? (
            materials.map((material: ICheckoutMaterial) => {
              const rowCells = [
                { key: 'name', value: material.material.name, statusView: [1, 2, 3, 4, 5] },
                { key: 'group', value: material.material.materialGroup?.name ?? '—', statusView: [1, 2, 3, 4, 5] },
                { key: 'code', value: material.material.code, statusView: [1, 2, 3, 4, 5] },
                { key: 'qty-checkout', value: material.quantityAtCheckout, statusView: [1, 2, 3, 4, 5] },
                { key: 'qty-checkin', value: material.quantityAtCheckin ?? '—', statusView: [3, 4, 5] },
                { key: 'notes', value: material.notes ?? '—', statusView: [3, 4, 5] },
              ]

              return (
                <TableRow key={material.id}>
                  {rowCells.map((cell) => (
                    cell.statusView.includes(status ?? 0) && (
                      <TableCell key={cell.key}>
                        {cell.value}
                      </TableCell>
                    )
                  ))}
                </TableRow>
              )
            })
          ) : (
            <TableRow>
              <TableCell colSpan={2} align="center">
                {translate('No Materials found')}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  )
}